import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface DimConfigurationDeleteButtonProps {
  index: number
  onDelete: (index: number) => Promise<void>
  disabled?: boolean
}

export const DimConfigurationDeleteButton = React.memo(
  ({ index, onDelete, disabled }: DimConfigurationDeleteButtonProps) => {
    const { t } = useTranslation()

    const handleClick = React.useCallback(() => {
      onDelete(index)
    }, [index, onDelete])

    return (
      <Button
        variant="tertiary"
        className="btn--borderless"
        onClick={handleClick}
        disabled={disabled}
        isIconOnly
        icon={IconName.BIN}
        isDanger
      >
        {t("General.Delete")}
      </Button>
    )
  }
)

DimConfigurationDeleteButton.displayName = "DimConfigurationDeleteButton"
